import { WorkflowFormSchema } from '@/features/workflow/models/workflow';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC, PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';
import type { z } from 'zod';

type FormValues = z.infer<typeof WorkflowFormSchema>;
type InitialFormValues = Partial<FormValues>;

export const WorkflowFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const formMethods = useForm<InitialFormValues, FormValues>({
    defaultValues: {
      title: '',
      content: null,
      remark: null,
      assigneeIds: [],
      sharedOrganizationRecursiveIds: [],
      tagIds: [],
    },
    resolver: zodResolver(WorkflowFormSchema),
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
